export interface TranslatedNameType {
  uuid: string;
  de?: string;
  en?: string;
  text?: string;
}

export interface TranslatedHistory {
  uuid: string;
  de: string;
  // eslint-disable-next-line camelcase
  de_old: string;
  en: string;
  // eslint-disable-next-line camelcase
  en_old: string;
}

export interface ExtendedTranslatedNameType extends TranslatedNameType {
  highlight?: boolean;
}

export enum Locale {
  de = 'de',
  en = 'en',
}
